import { createSelector } from 'reselect';

import { getFilterParamsAdapter, getTimeFilterParams } from './../../api-adapter';
import { getInterval } from '../../util';

const filtersStore = (store) => store.apps.analytics.filters;
const generalStore = (store) => store.apps.analytics.generalReducer;
const userStore = (store) => store.user;
export const testOverviewStore = (store) => store.apps.analytics.testOverview;

export const overviewSelector = createSelector([
  filtersStore,
  generalStore,
  testOverviewStore,
  userStore,
], (filterStore, general, testOverview, user) => ({
  errors: general.get('errors'),
  filters: filterStore.get('filters'),
  loading: general.get('loading'),
  selectedDateFilter: filterStore.get('selectedDateFilter'),
  totalRuns: testOverview.getIn(['trends', 'statusRecord', 'totalRuns', 'value']),
  trends: testOverview.get('trends'),
  user,
}));

export const testOverviewFilterParamsSelector = createSelector([
  filtersStore,
  (store, options) => options,
], (filters, options) => {
  const timeParam = getTimeFilterParams(filters.get('selectedDateFilter'));
  const timeParams = options?.priorData ? getTimeFilterParams(
    filters.get('selectedDateFilter'),
    Date.now() - (filters.getIn(['selectedDateFilter', 'value']) * 1000),
  ) : getTimeFilterParams(filters.get('selectedDateFilter'));

  return {
    ...getFilterParamsAdapter(filters.get('filters')),
    ...timeParams,
    interval: getInterval(timeParam.end - timeParam.start),
    ...options,
  };
});
